module.exports = __webpack_public_path__ + "static/media/brand.937f44ff.svg";